import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {CartEvents} from '@wix/wixstores-client-storefront-sdk/dist/es/src/apis/constants';

export class CartService {
  private readonly siteStore: SiteStore;

  constructor({siteStore}: {siteStore: SiteStore}) {
    this.siteStore = siteStore;
  }

  public clearCart(cartId: string): Promise<void> {
    if (this.siteStore.isEditorMode() || this.siteStore.isPreviewMode() || !cartId) {
      // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
      return;
    }
    this.siteStore.pubSubManager.publish(CartEvents.Cleared, {cartId}, false);
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    // eslint-disable-next-line sonarjs/no-redundant-jump
    return;
  }
}
